import React from 'react';

import PropTypes from 'prop-types';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import { getHighlightedText } from 'apps/auth/helpers/utils';

const PlaidBankItem = React.memo(({ bank, onClickHandler, query }) => {
    const logo = bank?.logo ? (
        <DiskBadge variant="hasBorderedImg" src={`data:image/png;base64, ${bank.logo}`} alt="" />
    ) : (
        <DiskBadge variant="tertiary" iconName="bank" />
    );

    return (
        <Panel type="button" isHoverable negativeMargin key={bank.id} onClick={() => onClickHandler(bank.id)}>
            <DiskBadgeWrapper>{logo}</DiskBadgeWrapper>
            {!!query ? <>{getHighlightedText(query, bank.name)}</> : <>{bank.name}</>}
        </Panel>
    );
});
PlaidBankItem.propTypes = {
    bank: PropTypes.object,
    onClickHandler: PropTypes.func,
};

export default PlaidBankItem;
